<template>
	<div>

		<table-list
			:records="mutatedChecklists"
			:fields="[
				{ label: 'Checklist Name',   key: 'name' },
				{ label: 'Checklist Items',  key: 'itemsText' }
			]"
			record-name="Checklist"
			:hide-record-count="!hideTitle"
			:sortable="true"
			:has-edit="true"
			edit-button-text="View"
			edit-button-icon="fa-eye"
			:has-delete="!hideDelete"
			:delete-endpoint="(resource) ? resource + '/delete': false"
			v-on:edit="openViewModal"
			v-on:delete="removeChecklist">

			<template v-if="!hideEdit">
				<button class="btn btn-primary" v-on:click="openEditListModal()">
					<i class="fa fa-plus"></i>
					New Checklist
				</button>
			</template>
		</table-list>

		<!------------------ View Checklist Modal ---------------------->

		<modal-dialog
			:modal-visible="viewModal.visible"
			title="View Checklist"
			modal-size="modal-lg"
			cancel-button-text="Done"
			:submit-visible="false"
			v-on:closeModal="viewModal.visible = false">

			<div v-if="viewModal.checklist" class="d-flex justify-content-between">

				<div class="d-flex align-items-center">
					<i v-if="!hideEdit" class="fa fa-pencil-alt icon-button mr-3" v-on:click="openEditListModal(viewModal.checklist)" title="Edit checklist name"></i> 
					<h3 class="mb-0">{{viewModal.checklist.name}}</h3>
				</div>

				<div v-if="!hideEdit">
					<button class="btn btn-primary" type="button" v-on:click="openEditItemModal()">
						<i class="fa fa-plus"></i>
						New Item
					</button>
				</div>

			</div>

			<table-list
				v-if="viewModal.checklist && 'items' in viewModal.checklist"
				:records="viewModal.checklist.items"
				:fields="[
					{ label: 'Description', key: 'fullDescription' }
				]"
				record-name="Item"
				:hide-record-count="true"
				:sortable="false"
				:rows-draggable="!hideEdit"
				:has-drag-handle="!hideEdit"
				:has-edit="!hideEdit"
				:has-delete="!hideEdit"
				v-on:edit="openEditItemModal"
				v-on:delete="deleteChecklistItem"
				v-on:dragEnd="reorderRows">
			</table-list>


		</modal-dialog>

		<!------------------ Edit Checklist DETAILS Modal ---------------------->
		<modal-dialog
			:modal-visible="editListModal.visible"
			:title="editListModal.title"
			v-on:confirm="saveChecklist(editListModal.payload, editListModal.checklist)"
			v-on:closeModal="editListModal.visible = false">

			<template v-if="editListModal.payload">

				<field
					label="Name"
					col-class="col-sm-3"
					v-model="editListModal.payload.name">
				</field>

			</template>
		</modal-dialog>


		<!------------------ Edit Checklist ITEM DETAILS Modal ---------------------->
		<modal-dialog
			:modal-visible="editItemModal.visible"
			:title="editItemModal.title"
			v-on:confirm="saveChecklistItems"
			v-on:closeModal="editItemModal.visible = false">

			<template v-if="editItemModal.payload">

				<field
					label="Description"
					col-class="col-sm-3"
					v-model="editItemModal.payload.description">
				</field>

				<field
					label="Optional?"
					col-class="col-sm-3"
					:params="{type: 'boolean'}"
					v-model="editItemModal.payload.optional">
				</field>

			</template>
		</modal-dialog>

	</div>
</template>
<script type="text/javascript">

import Widget from "@/components/Widget"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"

export default {
	name: "ChecklistTable",
	components: {
		Widget,
		TableList,
		Field,
		ModalDialog
	},
	props: [
		'value',
		'resource',
		'serviceId',
		'hideTitle',
		'hideEdit',
		'hideDelete'
	],
	data() {
		return {

			localValue: [],   // value/localValue are a list of Checklist

			viewModal: {
				visible: false,
				checklist: null
			},

			editListModal: {
				visible: false,
				title: "",
				checklist: null,
				payload: null   // copy of checklist
			},

			editItemModal: {
				visible: false,
				title: "",
				checklist: null,
				itemIndex: null,
				payload: null   // copy of checklist.items[itemIndex]
			},
		}
	},
	watch: {
		value() {
			this.localValue = (this.value) ? this.cloneObj(this.value) : []

			// Refresh view modal with new value
			if (this.viewModal.visible) {
				const checklist = this.localValue.find(cl => ('id' in cl && cl.id == this.viewModal.checklist.id))
				if (checklist)
					this.openViewModal(checklist)
				else
					this.viewModal.visible = false
			}
		}
	},
	computed: {
		mutatedChecklists() {
			return this.localValue.map(checklist => {
				return this.mutateChecklist(checklist)
			})
		}
	},
	methods: {

		change() {
			this.$nextTick(() => {
				this.$emit('input', this.localValue)
			})
		},

		removeChecklist(record, index) {
			this.localValue.splice(index, 1)
			this.$emit('delete', record, index)
			this.change()
		},

		reorderRows(event) {

			// Update our items list
			let items = this.cloneObj(this.viewModal.checklist.items)
			let movedItem = items.splice(event.oldIndex, 1)
			items.splice(event.newIndex, 0, movedItem[0])

			// Strip any fields that were temporarily added
			const newItems = this.cleanItems(items)

			// Save result
			const payload = {
				id: this.viewModal.checklist.id,
				items_json: JSON.stringify(newItems)
			}

			this.saveChecklist(payload, this.viewModal.checklist)
		},

		deleteChecklistItem(item, index) {

			// Update our items list
			let items = this.cloneObj(this.viewModal.checklist.items)
			items.splice(index, 1)

			// Strip any fields that were temporarily added
			const newItems = this.cleanItems(items)

			// Save result
			const payload = {
				id: this.viewModal.checklist.id,
				items_json: JSON.stringify(newItems)
			}

			this.saveChecklist(payload, this.viewModal.checklist)
		},

		saveChecklistItems() {

			let items = this.cloneObj(this.editItemModal.checklist.items)

			// Update our items list
			if (this.editItemModal.itemIndex > -1)
				items[this.editItemModal.itemIndex] = this.editItemModal.payload
			else
				items.push(this.editItemModal.payload)

			// Strip any fields that were temporarily added
			const newItems = this.cleanItems(items)

			// Save result
			const payload = {
				id: this.editItemModal.checklist.id,
				items_json: JSON.stringify(newItems)
			}

			this.saveChecklist(payload, this.editItemModal.checklist)
		},

		cleanItems(items) {
			const allowedFields = ['description', 'optional']

			return items.map(item => {
				Object.keys(item).forEach(key => {
					if (!allowedFields.includes(key))
						delete item[key]
					if (key == 'optional')
						item[key] = Boolean(item[key])
				})
				return item
			})

		},

		openEditItemModal(item=null, index=-1) {

			if (index < 0) {
				this.editItemModal.title = "New Checklist Item"
				item = {description: "", optional: false}
			} else {
				this.editItemModal.title = "Edit Checklist Item"
			}

			this.editItemModal.checklist = this.viewModal.checklist
			this.editItemModal.itemIndex = index
			this.editItemModal.payload = this.cloneObj(item)
			this.editItemModal.visible = true
		},

		saveChecklist(payload, checklist) {
			const vm = this

			if (this.serviceId && this.serviceId > 0)
				payload.service_id = this.serviceId

			this.postData(this.resource + "/save", payload).then(response => {
				if (response.success) {

					if (!('id' in payload))
						checklist.id = response.record_id

					Object.keys(payload).forEach(key => {
						checklist[key] = payload[key]
					})

					if (!('id' in payload))
						vm.localValue.push(checklist)

					vm.editListModal.visible = false
					vm.editItemModal.visible = false
					vm.mutateChecklist(checklist)
					vm.openViewModal(checklist)
					vm.change()
				}
			})
		},


		openEditListModal(checklist=false) {

			if (checklist) {
				this.editListModal.checklist = checklist
				this.editListModal.payload = this.cloneObj(checklist)
				this.editListModal.title = "Edit Checklist"

			} else {
				this.editListModal.checklist = {}
				this.editListModal.payload = {}
				this.editListModal.title = "New Checklist"
			}

			this.editListModal.visible = true
		},
		openViewModal(checklist) {
			this.viewModal.checklist = checklist
			this.viewModal.visible = true
		},

		mutateChecklist(checklist) {

			checklist.items = []

			if ('items_json' in checklist && checklist.items_json) {
				try {
					checklist.items = JSON.parse(checklist.items_json)
				} catch {}

				checklist.items = checklist.items.map(item => {
					item.fullDescription = item.description

					if ('optional' in item && item.optional)
						item.fullDescription += " <span class='text-danger'>(Optional)</span>"

					return item
				})
			}

			checklist.itemsText = "<ul class='pl-3 mb-0'>"

			checklist.itemsText += checklist.items.map((item, index) => {
				if (index < 2)
					return "<li style='margin: 2px 0;'>" + item.fullDescription + "</li>"
				else if (index == 2) {
					const remaining = checklist.items.length - 2
					return "<li style='margin: 2px 0;'>and " + remaining + " more...</li>"
				}
				return ""
			}).join("")

			checklist.itemsText += "</ul>"

			return checklist
		}
	},
	created() {
		this.localValue = (this.value) ? this.cloneObj(this.value) : []
	}
}
</script>


